<template>
  <draggable-file-input 
    @input="setFilesUpload"
  >
    <spinner v-if="loading != 0" />
    <ul v-else-if="files.length" class="files">
      <li v-for="file of files" class="image-item">
        <b-progress 
          v-if="isNativeFile(file)"
          class="loading-bar"
          animated
        >
          <b-progress-bar :value="100" variant="success">
            <span class="file-name">{{file.name}}</span>
          </b-progress-bar>
        </b-progress>
        <div 
          v-else
          class="image"
          :key="file.id"
          :style="`background-image: url(${file.url})`"
          @mouseover="setActiveIndex(file.id)"
        >
        </div>
        <div 
          v-if="activeIndex === file.id"
          class="actions"
          @mouseover="setActiveIndex(file.id)"
          @mouseout="setActiveIndex(-1)"
        >
          <router-link tag="button" :to="{ name: 'FileModal', query: fileQuery(file) }">
            <i class="mdi mdi-magnify-plus"></i>
          </router-link>
          <button @click="copyLinkToBuffer(file.url)"><i class="mdi mdi-link-variant"></i></button>
          <button @click="deleteFile(file.id)"><i class="mdi mdi-delete"></i></button>
        </div>
      </li>
    </ul>
  </draggable-file-input>
</template>
<script>
import swal from 'sweetalert2';
import request from 'superagent';
import { mapGetters } from 'vuex';
import Spinner from '@/components/Spinner';
import DraggableFileInput from '@/components/DraggableFileInput';
import FILES from '@/graphql/Campaigns/Files.gql';
import DELETE_FILE from '@/graphql/Campaigns/DeleteFile.gql';

export default {
  components: {
    DraggableFileInput,
    Spinner,
  },
  props: {
    campaignId: Number,
  },
  data() {
    return {
      files: [],
      loading: 0,
      activeIndex: -1,
    };
  },
  computed: {
    ...mapGetters(['getAuthToken']),
  },
  methods: {
    fileQuery(file) {
      return {
        ...this.$route.query,
        url: file.url,
        name: file.name,
      };
    },
    async setFilesUpload(filesToUpload) {
      if (!filesToUpload.length) {
        return;
      }
      const newFiles = [...filesToUpload];
      this.files = this.files.concat(newFiles);
      const uploadedFiles = await this.uploadFiles(newFiles);
      this.files = this.files.filter(f => !this.isNativeFile(f)).concat(uploadedFiles);
    },
    setActiveIndex(activeIndex) {
      this.activeIndex = activeIndex;
    },
    isNativeFile(file) {
      return file instanceof File;
    },
    async uploadFiles(files) {
      const data = new FormData();
      files.forEach(file => data.append('files[]', file, file.name));
      const response = await request
        .post(`${process.env.API_HOST}/upload-files/${this.$route.params.id}`)
        .set('Authorization', this.getAuthToken)
        .send(data);
      return response.body;
    },
    async deleteFile(fileId) {
      const { value: isConfirmed } = await swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
      });
      if (!isConfirmed) {
        return;
      }
      this.files = this.files.filter(f => f.id !== fileId);
      this.$apollo.mutate({
        mutation: DELETE_FILE,
        variables: { fileId },
      });
    },
    copyLinkToBuffer(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$notify({
        type: 'success',
        group: 'success',
        text: 'Link was copied to clipboard',
      });
    },
  },
  apollo: {
    files: {
      query: FILES,
      loadingKey: 'loading',
      fetchPolicy: 'network-only',
      variables() {
        return {
          campaignId: this.campaignId,
        };
      },
    },
  },
};
</script>
<style scoped>
.files {
  padding: 0;
  margin: 0;
  display: flex;
  flex: 1;
  list-style: none;
  flex-wrap: wrap;
}

.files .image-item {
  flex-basis: 200px;
  position: relative;
  height: 200px;
  display: flex;
  border-radius: 0.25rem;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
}

.files .image-item .image {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  border: 1px solid rgba(120, 130, 140, 0.13);
}

.files .image-item .actions {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #363d4a8f;
}

.files .image-item .actions button {
  margin: 0 5px;
  background-color: #212121;
  color: #fff;
  border: 1px solid #fff;
  font-size: 1.4rem;
  cursor: pointer;
  outline: 0;
}

.loading-bar {
  width: 90%;
}
.file-name {
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Campaigns/Details/Files.vue